import {
  Component,
  OnInit,
  AfterViewInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input,
  SimpleChanges,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-top-search-bar",
  templateUrl: "./top-search-bar.component.html",
  styleUrls: ["./top-search-bar.component.scss"],
  animations: fuseAnimations,
})
export class TopSearchBarComponent implements OnInit, AfterViewInit {

  private _onSearchCallback = (searchTerm:string) => {
  }

  @Input() set onSearchCallback(v:any) {
    this._onSearchCallback = v;
  }

  get onSearchCallback() {
    return this._onSearchCallback
  }

  constructor(private cdr: ChangeDetectorRef,private helper: HelperService) {
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  search(val:string) {
    if(this.onSearchCallback) {
      this.onSearchCallback(val)
    }
  }
}
